<template>
  <hypto-popup :title="'Settle To New'">
    <template v-slot:body>
      <div class="merge-fields">
        <bank-details @updateAccount="updateAccount" @setFunctions="setFunctions" />

        <md-field :class="{'input-error': $v.beneficiaryName.$error}">
          <label>Beneficiary Name</label>
          <md-input v-model="beneficiaryName" @blur="$v.beneficiaryName.$touch()"
                    @keyup.enter="settleToNew" />
        </md-field>
        <h6 class="error-message" v-if="$v.beneficiaryName.$error && !$v.beneficiaryName.required">Please enter Beneficiary Name</h6>
        <h6 class="error-message" v-else-if="$v.beneficiaryName.$error && !$v.beneficiaryName.alphaNumericSpace">Beneficiary Name should contain only alphanumeric characters and space</h6>
        <h6 class="error-message" v-else-if="$v.beneficiaryName.$error && !$v.beneficiaryName.minLength">Beneficiary Name should contain atleast 5 characters</h6>
        <h6 class="error-message" v-else-if="$v.beneficiaryName.$error && !$v.beneficiaryName.maxLength">Beneficiary Name should contain maximum 35 characters</h6>
      </div>
    </template>

    <template v-slot:footer>
      <error-info :errorList="formErrors.invalid_credit" />
      <button class="primary-btn align-r" @click="settleToNew">Submit</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import ErrorInfo from '@/components/global/ErrorInfo'
import BankDetails from '@/components/Bank/InputDetails'

import VaServices from '@/services/api/vaInvalidCredits'
import UpiServices from '@/services/api/upiInvalidCredits'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { alphaNumericSpace } from '@/utils/helpers/validators'
import { checkFormErrors, openPopup } from '@/utils/helpers'

export default {
  name: 'SettleNew',
  components: { BankDetails, HyptoPopup, ErrorInfo },
  data () {
    return {
      beneficiaryName: null,
      number: null,
      ifsc: null,
      accountStatus: false,
      bankFunctions: null,
      formErrors: {
        invalid_credit: []
      }
    }
  },
  props: {
    id: Number,
    page: {
      type: String,
      default: 'VA'
    }
  },
  validations: {
    beneficiaryName: {
      required,
      alphaNumericSpace,
      minLength: minLength(5),
      maxLength: maxLength(35)
    }
  },
  watch: {
    beneficiaryName () {
      this.formErrors.invalid_credit = []
    }
  },
  methods: {
    openPopup,
    checkFormErrors,
    getParams () {
      return {
        perform: 'SETTLE_TO_NEW',
        beneficiary_name: this.beneficiaryName,
        number: this.number,
        ifsc: this.ifsc
      }
    },
    settleToNew () {
      this.$v.$touch()
      this.bankFunctions.touchFields()
      if (this.accountStatus === 'SUCCESS' && !this.$v.$error && !this.checkFormErrors(this.formErrors)) {
        const params = this.getParams()
        const ApiServices = this.page === 'UPI' ? UpiServices : VaServices

        ApiServices.refundAction(this.id, params).then(response => {
          if (response.success) {
            this.successToastMsg(response.message)
            this.$emit('refreshList', response.data)
          } else {
            this.errorToastMsg(response.message)
          }
        }).catch(error => {
          let data = error.body
          this.formErrors = {
            ...this.formErrors,
            ...data.reason
          }
        })
      }
    },
    updateAccount (account, status) {
      this.number = account.number
      this.ifsc = account.ifsc
      this.accountStatus = status
      this.formErrors.invalid_credit = []
    },
    setFunctions (fun) {
      this.bankFunctions = fun()
    }
  }
}
</script>
